import apiClient, { buildQueryParams } from '../utils/apiClient';
import { handleError } from '../utils/errorHandler';
import { API_ENDPOINTS } from '../constants/apiEndpoints.constants';

/**
 * Service for Vehicle Odometers API calls
 */
const vehicleOdometerService = {
  /**
   * Get all vehicle odometers with pagination and filters
   */
  getAllOdometers: async (params = {}) => {
    try {
      const {
        page = 1,
        limit = 50,
        search = '',
        status = '',
        sortBy = 'createdAt',
        sortOrder = 'desc',
      } = params;

      const queryParams = buildQueryParams({
        page,
        limit,
        search,
        status,
        sortBy,
        sortOrder,
      });

      return await apiClient.get(`${API_ENDPOINTS.VEHICLE_ODOMETERS.LIST}?${queryParams}`);
    } catch (error) {
      throw new Error(handleError(error, 'vehicleOdometerService.getAllOdometers'));
    }
  },

  /**
   * Get a single vehicle odometer by ID
   */
  getOdometerById: async (id) => {
    try {
      return await apiClient.get(API_ENDPOINTS.VEHICLE_ODOMETERS.GET_BY_ID(id));
    } catch (error) {
      throw new Error(handleError(error, 'vehicleOdometerService.getOdometerById'));
    }
  },

  /**
   * Create a new vehicle odometer
   */
  createOdometer: async (odometerData) => {
    try {
      return await apiClient.post(API_ENDPOINTS.VEHICLE_ODOMETERS.CREATE, odometerData);
    } catch (error) {
      throw new Error(handleError(error, 'vehicleOdometerService.createOdometer'));
    }
  },

  /**
   * Update a vehicle odometer
   */
  updateOdometer: async (id, odometerData) => {
    try {
      return await apiClient.put(API_ENDPOINTS.VEHICLE_ODOMETERS.UPDATE(id), odometerData);
    } catch (error) {
      throw new Error(handleError(error, 'vehicleOdometerService.updateOdometer'));
    }
  },

  /**
   * Delete a vehicle odometer
   */
  deleteOdometer: async (id) => {
    try {
      return await apiClient.delete(API_ENDPOINTS.VEHICLE_ODOMETERS.DELETE(id));
    } catch (error) {
      throw new Error(handleError(error, 'vehicleOdometerService.deleteOdometer'));
    }
  },

  /**
   * Delete multiple vehicle odometers
   */
  deleteMultipleOdometers: async (ids) => {
    try {
      return await apiClient.delete(API_ENDPOINTS.VEHICLE_ODOMETERS.DELETE_MULTIPLE, { data: { ids } });
    } catch (error) {
      throw new Error(handleError(error, 'vehicleOdometerService.deleteMultipleOdometers'));
    }
  },

  /**
   * Toggle odometer status
   */
  toggleOdometerStatus: async (id) => {
    try {
      return await apiClient.patch(API_ENDPOINTS.VEHICLE_ODOMETERS.TOGGLE_STATUS(id));
    } catch (error) {
      throw new Error(handleError(error, 'vehicleOdometerService.toggleOdometerStatus'));
    }
  },
};

export default vehicleOdometerService;
